import * as React from 'react';
import {connect} from "react-redux";
import {  withRouter} from "react-router-dom";
import RootRoutes from "../routes/RootRoutes";
import Navigation from "../components/Navigation";
import HeaderController from "./HeaderController";

class IndexController extends React.Component {
	state = {
		menu: true
	};
	render() {
		// const {menu} = this.state;
		return (
			<div>
				{/*<HeaderController/>*/}
				<section id="ah-body">
					<Navigation/>
					<main className="ah-main-body">
						<RootRoutes />
					</main>
				</section>
			</div>
		);
	}
}

IndexController = withRouter(connect()(IndexController));
export default IndexController;


// WEBPACK FOOTER //
// ./src/containers/IndexController.js